import {pluralize} from "@pg-mono/string-utils";

const roomPlural = pluralize(["pokoju", "pokoi", "pokoi"]);

export function convertToRoomsSearchPhrase(roomsMin: number | null, roomsMax: number | null, displayAsNumber: boolean): string {
    if (typeof roomsMin === "number" && typeof roomsMax === "number") {
        return convertToRangeText(roomsMin, roomsMax, displayAsNumber);
    }

    if (typeof roomsMin === "number") {
        return convertToMinText(roomsMin, displayAsNumber);
    }

    if (typeof roomsMax === "number") {
        return convertToMaxText(roomsMax, displayAsNumber);
    }

    return "";
}

function convertToRangeText(roomsFrom: number, roomsTo: number, displayAsNumber: boolean) {
    if (roomsFrom === roomsTo) {
        const roomInRange = convertToInRangeValues(roomsTo);
        return convertToSingleValueText(roomInRange, displayAsNumber);
    }

    const maxFrom = Math.max(1, roomsFrom);
    const minTo = Math.min(5, roomsTo);

    if (maxFrom === 1 && minTo === 5) {
        return "";
    }

    if (minTo === 5) {
        return `od ${maxFrom} ${roomPlural(maxFrom)}`;
    }

    if (maxFrom === 1) {
        return `do ${minTo} ${roomPlural(minTo)}`;
    }

    return `od ${maxFrom} do ${minTo} ${roomPlural(minTo)}`;
}

function convertToMinText(roomsFrom: number, displayAsNumber: boolean) {
    const minInRange = convertToInRangeValues(roomsFrom);

    if (minInRange === 1) {
        return "";
    }

    if (minInRange === 5) {
        return convertToSingleValueText(minInRange, displayAsNumber);
    }

    return `od ${minInRange} ${roomPlural(minInRange)}`;
}

function convertToMaxText(roomsTo: number, displayAsNumber: boolean) {
    const maxInRange = convertToInRangeValues(roomsTo);

    if (maxInRange === 1) {
        return convertToSingleValueText(maxInRange, displayAsNumber);
    }

    if (maxInRange === 5) {
        return "";
    }

    return `do ${maxInRange} ${roomPlural(maxInRange)}`;
}

function convertToInRangeValues(rooms: number) {
    let roomsInRange = rooms;

    roomsInRange = Math.max(1, roomsInRange);
    roomsInRange = Math.min(5, roomsInRange);

    return roomsInRange;
}

const roomsVerbose = {
    1: "jednopokojowe",
    2: "dwupokojowe",
    3: "trzypokojowe",
    4: "czteropokojowe",
    5: "pięciopokojowe i więcej"
} as Record<number, string>;

function convertToSingleValueText(rooms: number, displayAsNumber: boolean) {
    if (rooms === 1) {
        return roomsVerbose[1];
    }

    if (displayAsNumber) {
        return `${rooms} pokojowe`;
    }

    return roomsVerbose[rooms];
}
import {pluralize} from "@pg-mono/string-utils";

const roomPlural = pluralize(["pokoju", "pokoi", "pokoi"]);

export function convertToRoomsSearchPhrase(roomsMin: number | null, roomsMax: number | null, displayAsNumber: boolean): string {
    if (typeof roomsMin === "number" && typeof roomsMax === "number") {
        return convertToRangeText(roomsMin, roomsMax, displayAsNumber);
    }

    if (typeof roomsMin === "number") {
        return convertToMinText(roomsMin, displayAsNumber);
    }

    if (typeof roomsMax === "number") {
        return convertToMaxText(roomsMax, displayAsNumber);
    }

    return "";
}

function convertToRangeText(roomsFrom: number, roomsTo: number, displayAsNumber: boolean) {
    if (roomsFrom === roomsTo) {
        const roomInRange = convertToInRangeValues(roomsTo);
        return convertToSingleValueText(roomInRange, displayAsNumber);
    }

    const maxFrom = Math.max(1, roomsFrom);
    const minTo = Math.min(5, roomsTo);

    if (maxFrom === 1 && minTo === 5) {
        return "";
    }

    if (minTo === 5) {
        return `od ${maxFrom} ${roomPlural(maxFrom)}`;
    }

    if (maxFrom === 1) {
        return `do ${minTo} ${roomPlural(minTo)}`;
    }

    return `od ${maxFrom} do ${minTo} ${roomPlural(minTo)}`;
}

function convertToMinText(roomsFrom: number, displayAsNumber: boolean) {
    const minInRange = convertToInRangeValues(roomsFrom);

    if (minInRange === 1) {
        return "";
    }

    if (minInRange === 5) {
        return convertToSingleValueText(minInRange, displayAsNumber);
    }

    return `od ${minInRange} ${roomPlural(minInRange)}`;
}

function convertToMaxText(roomsTo: number, displayAsNumber: boolean) {
    const maxInRange = convertToInRangeValues(roomsTo);

    if (maxInRange === 1) {
        return convertToSingleValueText(maxInRange, displayAsNumber);
    }

    if (maxInRange === 5) {
        return "";
    }

    return `do ${maxInRange} ${roomPlural(maxInRange)}`;
}

function convertToInRangeValues(rooms: number) {
    let roomsInRange = rooms;

    roomsInRange = Math.max(1, roomsInRange);
    roomsInRange = Math.min(5, roomsInRange);

    return roomsInRange;
}

const roomsVerbose = {
    1: "jednopokojowe",
    2: "dwupokojowe",
    3: "trzypokojowe",
    4: "czteropokojowe",
    5: "pięciopokojowe i więcej"
} as Record<number, string>;

function convertToSingleValueText(rooms: number, displayAsNumber: boolean) {
    if (rooms === 1) {
        return roomsVerbose[1];
    }

    if (displayAsNumber) {
        return `${rooms} pokojowe`;
    }

    return roomsVerbose[rooms];
}
